import React, { FC } from 'react';
import { Button, Modal } from '../../../../../shared/ui';
import { useSelector } from 'react-redux';
import { fathomModel } from '../../../../../entities/fathom';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const DisconnectFathomConfirmationModal: FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const isDisconnectingFromFathom = useSelector(
    fathomModel.selectors.selectIsDisconnecting
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Disconnect from Fathom"
      actionButton={
        <Button
          fullWidth
          color="destructive"
          variant="text"
          onClick={onConfirm}
          loading={isDisconnectingFromFathom}
        >
          Disconnect
        </Button>
      }
    >
      <div className="text-sm text-gray-600">
        Are you sure you want to disconnect from Fathom? Your team will no
        longer be able to create pages using Fathom call transcripts.
      </div>
    </Modal>
  );
};
